import $ from 'jquery';
import numeral from 'numeral';
import {RangeFee} from './FeeSchedule';
import _ from "lodash";

class RangeTable {

  constructor(form) {
    this.form = form;
    this.feeSchedule = form.feeSchedule;
    this.$table = form.$form.find('#fee_schedule_ranges');
    this.$tbody = this.$table.children('tbody');
    this.colCount = 7;
  }

  isEmpty() {
    return !this.feeSchedule.ranges.length;
  }

  emptyRow() {
    this.$tbody.empty();

    var $tr = $('<tr/>').addClass('empty-range-fees').appendTo(this.$tbody);
    var $td = $('<td/>')
      .attr('colspan', this.colCount)
      .addClass('text-muted')
      .appendTo($tr);
    $td.text('This fee schedule has no range fees');
  }

  buildRows() {
    this.$tbody.find('tr.empty-range-fees').remove();
    let _this = this;

    this.feeSchedule.ranges.forEach(function(item, index, array) {
      let $tr = _this.buildRow(item);
      _this.$tbody.append($tr);
    });
  }

  insertRow(ix, rangeFee) {
    let $trEmpty = this.$tbody.find('tr.empty-range-fees');
    if ($trEmpty.length) {
      this.buildRows();
    }
    else {
      $trEmpty.remove();
      let $tr = this.buildRow(rangeFee);
      let $trNext = this.$tbody.find('tr:eq(' + ix + ')');
      $trNext.before($tr);
      this.refreshRowLowerBound($trNext);
    }
  }

  buildRow(rangeFee) {
    let $tr = $('<tr/>')
      .attr('data-uuid', rangeFee.uuid)
      .data('item', rangeFee);

    if (rangeFee.is_new) {
      $tr.addClass('table-info');
    }

    let $td = $('<td/>').addClass('text-right').appendTo($tr);
    $('<p/>').addClass('form-control-plaintext range-fee-lower-bound')
      .text(numeral(rangeFee.lower_bound()).format('$0,0.000'))
      .appendTo($td);

    let $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'range_fee_type[' + rangeFee.uuid + ']')
      .attr('data-field', 'type')
      .val(rangeFee.type)
      .appendTo($td);

    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'range_fee_uuid[]')
      .attr('data-field', 'uuid')
      .val(rangeFee.uuid)
      .appendTo($td);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    $('<p/>').addClass('form-control-plaintext')
      .text('-')
      .appendTo($td);

    let $ig = null;

    $td = $('<td/>').appendTo($tr);
    if (rangeFee.upper_bound === null) {
      $('<p/>').addClass('form-control-plaintext')
        .text('and above')
        .appendTo($td);
      $hidden = $('<input/>').attr('type', 'hidden')
        .attr('name', 'range_fee_upper_bound[' + rangeFee.uuid + ']')
        .attr('data-field', 'upper_bound')
        .val(rangeFee.upper_bound)
        .appendTo($td);
    }
    else {
      $ig = $('<div/>').addClass('input-group input-group-sm')
        .appendTo($td);
      let addonDiv = $('<div/>').addClass('input-group-prepend')
        .appendTo($ig);
      $('<span/>').addClass('input-group-addon')
        .text('$')
        .appendTo(addonDiv);
      $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
        .attr('data-field', 'upper_bound')
        .attr('name', 'range_fee_upper_bound[' + rangeFee.uuid + ']')
        .val(rangeFee.upper_bound)
        .appendTo($ig);
    }

    $td = $('<td/>').appendTo($tr);
    $ig = $('<div/>').addClass('input-group input-group-sm')
      .appendTo($td);
    let $input = $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'range_fee_fee[' + rangeFee.uuid + ']')
      .attr('data-field', 'fee')
      .val(rangeFee.fee)
      .appendTo($ig);
    if (rangeFee.upper_bound === null) {
      $input.attr('placeholder', 'blank if n/a');
    }

    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'range_adjuster_fee_base[' + rangeFee.uuid + ']')
      .attr('data-field', 'adjuster_fee_base')
      .attr('placeholder', 'blank if n/a')
      .val(rangeFee.adjuster_fee_base)
      .appendTo($ig);

    let $bg = $('<div/>').addClass('input-group-append')
      .appendTo($ig);
    let $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-range-fee-type')
      .attr('data-range-fee-type', '$')
      .text('$')
      .appendTo($bg);
    if (rangeFee.type === '$') $btn.removeClass('btn-default').addClass('btn-primary active');

    $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-range-fee-type')
      .attr('data-range-fee-type', '%')
      .text('%')
      .appendTo($bg);
    if (rangeFee.type === '%') $btn.removeClass('btn-default').addClass('btn-primary active');

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('input-group range-fee-minimum')
      .appendTo($td);
    let addonDiv = $('<div/>').addClass('input-group-prepend')
      .appendTo($ig);
    $('<span/>').addClass('input-group-addon')
      .text('$')
      .appendTo(addonDiv);
    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'range_fee_minimum[' + rangeFee.uuid + ']')
      .attr('data-field', 'minimum')
      .val(rangeFee.minimum)
      .appendTo($ig);

    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'range_adjuster_fee_base_minimum[' + rangeFee.uuid + ']')
      .attr('data-field', 'adjuster_fee_base_minimum')
      .attr('placeholder', 'blank if n/a')
      .val(rangeFee.adjuster_fee_base_minimum)
      .appendTo($ig);

    let $blank = $('<p/>').addClass('form-control-plaintext')
      .text('-')
      .appendTo($td);

    if (rangeFee.type === '%') {
      $blank.addClass('d-none');
      $ig.removeClass('d-none');
    }
    else {
      $blank.removeClass('d-none');
      $ig.addClass('d-none');
    }

    $td = $('<td/>').appendTo($tr);

    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'range_fee_adjuster_type[' + rangeFee.uuid + ']')
      .attr('data-field', 'adjuster_type')
      .val(rangeFee.adjuster_type)
      .appendTo($td);

    $ig = $('<div/>').addClass('input-group input-group-sm')
      .appendTo($td);
    $input = $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'range_fee_adjuster_fee[' + rangeFee.uuid + ']')
      .attr('data-field', 'adjuster_fee')
      .attr('placeholder', 'leave blank if not applicable')
      .val(rangeFee.adjuster_fee)
      .appendTo($ig);

    $bg = $('<div/>').addClass('input-group-append')
      .appendTo($ig);
    $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-range-fee-adjuster-type')
      .attr('data-range-fee-adjuster-type', '$')
      .text('$')
      .appendTo($bg);
    if (rangeFee.adjuster_type === '$') $btn.removeClass('btn-default').addClass('btn-primary active');

    $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-range-fee-adjuster-type')
      .attr('data-range-fee-adjuster-type', '%')
      .text('%')
      .appendTo($bg);
    if (rangeFee.adjuster_type === '%') $btn.removeClass('btn-default').addClass('btn-primary active');

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);

    if (rangeFee.upper_bound !== null) {
      $btn = $('<button/>').attr('type', 'button')
        .addClass('btn').addClass('btn-danger')
        .attr('data-action', 'remove-range-fee')
        .appendTo($td);
      $('<i/>').addClass('fa fa-trash').appendTo($btn);
    }

    return $tr;
  }

  init() {
    this.setupEvents();

    if (this.isEmpty()) {
      this.emptyRow();
    }
    else {
      this.buildRows();
    }
  }

  clearNewRow() {
    this.$table
      .find('#new_upper_bound')
      .val('')
      .prop('disabled', false);
    this.$table
      .find('#new_fee')
      .val('');
    this.$table
      .find('#new_adjuster_fee_base')
      .val('');
    this.$table
      .find('#new_fee')
      .closest('.input-group')
      .find('.active[data-action=select-range-fee-type]')
      .removeClass('active btn-primary')
      .addClass('btn-default');
    this.$table
      .find('#new_fee')
      .closest('.input-group')
      .find('[data-range-fee-type="$"]')
      .removeClass('btn-default')
      .addClass('active btn-primary');
    this.$table
      .find('#new_minimum')
      .val('');
    this.$table
      .find('#new_adjuster_fee_base_minimum')
      .val('');
    this.$table
      .find('#new_minimum')
      .closest('.input-group')
      .addClass('d-none');
    this.$table
      .find('#new_adjuster_fee')
      .val('');
    this.$table
      .find('#new_adjuster_fee')
      .closest('.input-group')
      .find('.active[data-action=select-range-fee-adjuster-type]')
      .removeClass('active btn-primary')
      .addClass('btn-default');
    this.$table
      .find('#new_adjuster_fee')
      .closest('.input-group')
      .find('[data-range-fee-adjuster-type="$"]')
      .removeClass('btn-default')
      .addClass('active btn-primary');
  }

  addRow(btn) {
    let data = this.getNewRangeFeeData();
    let rangeFee = new RangeFee(data);
    let ix = this.feeSchedule.addRangeFee(rangeFee);
    this.insertRow(ix, rangeFee);
    this.clearNewRow();
  }

  removeRow(btn) {
    let $tr = $(btn).closest('tr');
    let uuid = $tr.data('uuid');
    let $trNext = $tr.next('tr');

    $tr.remove();

    this.feeSchedule.removeRangeFee(uuid);

    if ($trNext.length) {
      this.refreshRowLowerBound($trNext);
    }

    if (this.isEmpty()) {
      this.emptyRow();
    }
  }

  selectFeeType(btn) {
    let $btn = $(btn);
    let $tr = $btn.closest('tr');
    let uuid = $tr.data('uuid');
    let feeType = $btn.data('range-fee-type');
    let $activeBtn = $btn.closest('td').find('.active[data-action=select-range-fee-type]');
    let $feeTypeInput = $tr.find('input:hidden[name^="range_fee_type"]');

    $activeBtn.removeClass('active btn-primary').addClass('btn-default');
    $btn.removeClass('btn-default').addClass('btn-primary active');

    $feeTypeInput.val(feeType);

    let $igMinimum = $tr.find('.input-group.range-fee-minimum');
    let $blank = $igMinimum.closest('td').find('.form-control-plaintext');

    if (feeType === '%') {
      $igMinimum.removeClass('d-none');
      $blank.addClass('d-none');
    }
    else {
      $igMinimum.addClass('d-none');
      $blank.removeClass('d-none');
    }
  }

  selectFeeAdjusterType(btn) {
    let $btn = $(btn);
    let $tr = $btn.closest('tr');
    let uuid = $tr.data('uuid');
    let feeType = $btn.data('range-fee-adjuster-type');
    let $activeBtn = $btn.closest('td').find('.active[data-action=select-range-fee-adjuster-type]');
    let $feeTypeInput = $tr.find('input:hidden[name^="range_fee_adjuster_type"]');

    $activeBtn.removeClass('active btn-primary').addClass('btn-default');
    $btn.removeClass('btn-default').addClass('btn-primary active');

    $feeTypeInput.val(feeType);
  }

  refreshRowLowerBound($tr) {
    let rangeFee = $tr.data('item');
    if (rangeFee) {
      $tr.find('.range-fee-lower-bound').text(numeral(rangeFee.lower_bound()).format('$0,0.000'));
    }
  }

  getNewRangeFeeData() {
    let data = {};
    data.is_new = true;
    data.valid = true;
    data.upper_bound = parseFloat(this.$table.find('#new_upper_bound').val());
    data.fee = parseFloat(this.$table.find('#new_fee').val());
    data.adjuster_fee_base = parseFloat(this.$table.find('#new_adjuster_fee_base').val());
    data.type = this.$table.find('#new_fee').closest('.input-group').find('.active[data-action=select-range-fee-type]').data('range-fee-type');
    data.minimum = parseFloat(this.$table.find('#new_minimum').val());
    data.adjuster_fee_base_minimum = parseFloat(this.$table.find('#new_adjuster_fee_base_minimum').val());
    data.adjuster_fee = this.$table.find('#new_adjuster_fee').val();
    data.adjuster_fee = _.isEmpty(data.adjuster_fee) ? null : parseFloat(data.adjuster_fee);
    data.adjuster_type = this.$table.find('#new_adjuster_fee')
      .closest('.input-group')
      .find('.active[data-action=select-range-fee-adjuster-type]')
      .data('range-fee-adjuster-type');

    if (data.upper_bound !== null && (isNaN(data.upper_bound) || data.upper_bound <= 0 )) {
      data.valid = false;
    }
    if (isNaN(data.fee) || data.fee <= 0) {
      data.valid = false;
    }
    if (data.type !== '%' && data.type !== '$') {
      data.valid = false;
    }
    if (data.type === '%' && !isNaN(data.minimum) && data.minimum < 0) {
      data.valid = false;
    }
    if (data.type === '%' && !isNaN(data.fee) && data.fee > 100) {
      data.valid = false;
    }

    if (data.adjuster_fee !== null) {
      if (isNaN(data.adjuster_fee) || data.adjuster_fee <= 0) {
        data.valid = false;
      }
      if (data.adjuster_type !== '%' && data.adjuster_type !== '$') {
        data.valid = false;
      }
      if (data.adjuster_type === '%' && !isNaN(data.adjuster_fee) && data.adjuster_fee > 100) {
        data.valid = false;
      }
    }

    return data;
  }

  getRowData($tr) {
    let data = {};
    $tr.find('[data-field]').each(function(ix) {
      let $el = $(this);
      data[$el.data('field')] = $el.val();
    });
    return data;
  }

  validateNewRow() {
    let data = this.getNewRangeFeeData();

    if (data.valid) {
      this.$table.find('button[data-action=add-range-fee]').prop('disabled', false);
    }
    else {
      this.$table.find('button[data-action=add-range-fee]').prop('disabled', true);
    }
  }

  highlightIfDirty($tr) {
    let rangeFee = $tr.data('item');
    if (rangeFee.is_new) return;

    let data = this.getRowData($tr);
    if (rangeFee.isDirty(data)) {
      $tr.addClass('table-warning');
    }
    else {
      $tr.removeClass('table-warning');
    }
  }

  setupEvents() {
    let _this = this;

    this.$table.on('click', '[data-action=add-range-fee]', function(e) {
      _this.addRow(e.currentTarget);
    }).on('click', '[data-action=remove-range-fee]', function(e) {
      _this.removeRow(e.currentTarget);
    }).on('click', '[data-action=select-range-fee-type]', function(e) {
      _this.selectFeeType(e.currentTarget);
      _this.validateNewRow();
    }).on('click', '[data-action=select-range-fee-adjuster-type]', function(e) {
      _this.selectFeeAdjusterType(e.currentTarget);
      _this.validateNewRow();
    }).on('keyup', '#new_upper_bound,#new_fee,#new_minimum,#new_adjuster_fee', function(e) {
      _this.validateNewRow();
    }).on('click', 'tbody [data-action=select-range-fee-type]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
    }).on('click', 'tbody [data-action=select-range-fee-adjuster-type]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
    }).on('keyup', 'tbody input[type=text], tbody input[type=text]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
    });
  }
}

export default RangeTable;
